<script>
import $ from 'jquery';
import axios from "axios";

export default {
  name: 'ServiceRecordModal',
  inject: ['eventHub'],
  created() {
    this.eventHub.$on('service-record-modal', () => {
      this.init();
      this.loadCustomers();
      $('#service-record').modal('show');
    })
  },
  data () {
    return {
      customers: null,
      customerId: null,
      customerServices: null,
      loading: false,
      ticketsSelectedId: [],
      ticketsSelected: [],
      timeSpent: 0,
      amountTimeSpent: 0,
      amountExpenses: 0,
      amountDiscount: 0,
      totalAmount: 0,
      note: '',
      errors: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      },
    }
  },
  methods: {
    init () {
      this.amountTimeSpent = 0;
      this.amountExpenses = 0;
      this.timeSpent = 0;
      this.amountDiscount = 0;
      this.customerId = null;
      this.customerServices = null;
      this.note = '';
      this.totalAmount = 0;
      this.ticketsSelected = [];
      this.ticketsSelectedId = [];
    },
    loadCustomers () {
      axios
        .get('/api/customers/tickets/not-invoiced')
        .then(({ data }) => this.customers = data.data);
    },
    loadTickets () {
      if (!this.customerId) {
        this.init();
        return;
      }

      this.loading = true

      axios
        .get(`/api/customer-service/not-invoiced?customer=${this.customerId}`)
        .then(({ data }) => this.customerServices = data.data)
        .catch(() => this.$toast.error('Erro ao carregar Tickets'))
        .then(() => this.loading = false);
    },
    selectTicket (ticket) {
      const index = this.ticketsSelected.findIndex(item => item.id === ticket.id);

      if (index !== -1) {
        this.ticketsSelected.splice(index, 1);
      } else {
        this.ticketsSelected.push(ticket);
      }

      this.calculateResume();
    },
    calculateResume () {
      this.amountTimeSpent = 0;
      this.amountExpenses = 0;
      this.timeSpent = 0;
      this.ticketsSelected.forEach(item => {
        let amount = item.is_fixed_value ? parseFloat(item.fixed_value) : item.amount_time_spent;
        this.amountTimeSpent = this.amountTimeSpent + amount;
        this.amountExpenses = this.amountExpenses + item.amount_expense;
        this.timeSpent = this.timeSpent + item.time_spent;
      })

      this.calculateTotal();
    },
    calculateTotal () {
      const discount = this.sanitizeMoney(this.amountDiscount)

      this.totalAmount = this.amountTimeSpent + this.amountExpenses - discount;
    },
    sanitizeMoney (valor) {
      if (valor.indexOf('R$ ') === -1)
        return valor;

      valor = valor.replace('R$ ', '');
      valor = valor.replace('.', '');
      valor = valor.replace(',', '');
      const end = valor.slice(-2);

      return valor.slice(0, -2) + '.' + end;
    },
    formatDateBrToView(originalDate) {
      const data = new Date(originalDate);
      let timezoneOffset = -180;
      data.setMinutes(data.getMinutes() - timezoneOffset);
      return data.toLocaleDateString("pt-BR");
    },
    secondsToDate(seconds) {
      if (isNaN(seconds)) {
        return '00:00:00'
      }
      let hours = Math.floor(seconds / 3600)
      seconds %= 3600
      let minutes = Math.floor(seconds / 60)
      seconds = seconds % 60

      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
    },
    store () {
      this.loading = true
      let payload = {
        customer_id: this.customerId,
        customer_services: this.ticketsSelectedId,
        amount_discount: parseFloat(this.sanitizeMoney(this.amountDiscount)),
        note: this.note,
      };

      axios
        .post('/api/service-record', payload)
        .then(({ data }) => {
          this.$toast.success('Ficha gerada com sucesso!')
          this.init();
          this.showServiceRecord(data.data)
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.fail();
        })
        .then(() => this.loading = false)
    },
    fail() {
      let message = ''
      for (let i in this.errors) {
        message = this.errors[i] + '<br />' + message
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message
      });
    },
    showServiceRecord (serviceRecord) {
      this.$router.push(`/service-record/${serviceRecord.id}/show`)
      $('#service-record').modal('hide');
    }
  }
}
</script>

<template>
  <div
    class="modal fade"
    id="service-record"
    tabindex="-1"
    aria-labelledby="service-record"
    aria-hidden="true"
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Gerar Ficha</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading">
            <div v-if="loading" class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="container-fluid">
              <div class="input-form col-sm-3">
                <v-select
                  :reduce="item => item.id"
                  placeholder="Cliente"
                  label="name"
                  v-model="customerId"
                  :options="customers"
                  v-if="customers"
                  @input="loadTickets"
                />
              </div>
            </div>
            <div class="container-fluid mt-4 border table-responsive">
              <h6 class="text-center mt-3"><strong>Lista de tickts não faturados</strong></h6>
              <table class="table table-striped mt-4">
                <thead>
                <tr>
                  <th>Criado em</th>
                  <th>Horas</th>
                  <th>R$ Horas</th>
                  <th>R$ Despesas</th>
                  <th>Fixo</th>
                  <th>Status</th>
                  <th>Faturar</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="customerService in customerServices" :key="customerService.id">
                  <td>{{ formatDateBrToView(customerService.created_at) }}</td>
                  <td>{{ secondsToDate(customerService.time_spent) }}</td>
                  <td><money class="hide-input" :value="customerService.is_fixed_value ? customerService.fixed_value : customerService.amount_time_spent" disabled /></td>
                  <td><money class="hide-input" v-model="customerService.amount_expense" disabled /></td>
                  <td>{{ customerService.is_fixed_value ? 'Sim' : 'Não' }}</td>
                  <td>{{ customerService.readable_status }}</td>
                  <td>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="customerService.id"
                      :value="customerService.id"
                      :disabled="customerService.status != 'completed'"
                      v-model="ticketsSelectedId"
                      @change="selectTicket(customerService)"
                    >
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="container-fluid mt-4 border table-responsive">
              <h6 class="text-center mt-3"><strong>Resumo com base na seleção</strong></h6>

              <table class="table table-striped mt-4">
                <thead>
                <tr>
                  <th>Horas</th>
                  <th>R$ Horas</th>
                  <th>R$ Despesas</th>
                  <th>Desconto</th>
                  <th>Total</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ secondsToDate(timeSpent) }}</td>
                  <td><money class="hide-input" v-model="amountTimeSpent" disabled /></td>
                  <td><money class="hide-input" v-model="amountExpenses" disabled /></td>
                  <td>
                    <input
                      class="hide-input"
                      v-money="money"
                      v-model.lazy="amountDiscount"
                      @blur="calculateTotal"
                    />
                  </td>
                  <td><money class="hide-input" v-model="totalAmount" disabled /></td>
                </tr>
                </tbody>
              </table>
              <textarea class="form-control mb-3" placeholder="Observações:" v-model="note"></textarea>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button
            class="btn btn-success"
            type="button"
            @click="store"
            :disabled="!ticketsSelectedId.length"
          >
            Gerar Ficha
          </button>
          <button class="btn btn-secondary" type="button" @click="init">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>
